<script setup>
import '@/assets/cloudCounter/css/style.css';
import Tesseract from '@/assets/cloudCounter/library/tesseract.esm.min.js';
import { ref, computed, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import ImageUploadBox from '@/components/cloudCounter/ImageUploadBox.vue';

// console.log(Tesseract);
// const props = defineProps({

// });

const goNextPage = () => {
    console.log('Go! Go! Go!');
}

const frontImageSrc = ref('');
const backImageSrc = ref('');

const inputId = ref('');
const inputDate = ref('');
const inputCity = ref('');
const inputType = ref('');

const goNextPageDisable = computed(() => (frontImageSrc.value === '' || backImageSrc.value === '' || inputId.value === '' || inputDate.value === '' || inputCity.value === '' || inputType.value === ''));



const recognize = (e, { src, handle }) => {

    src.value = URL.createObjectURL(e.target.files[0]);

    if (typeof handle === 'function') {
        handle(e);
    }

}

const idFormVisible = ref(false);
const isRecognizing = ref(false);
const frontImageRecognize = async (e) => {

    isRecognizing.value = true;

    const worker = await Tesseract.createWorker("chi_tra");
    const ret = await worker.recognize(e.target.files[0]);

    idFormVisible.value = true;
    isRecognizing.value = false;

    const resultArray = ret.data.text.split('\n');
    let result = '';

    for (let i = (resultArray.length - 1); i >= 0; i--) {
        const element = resultArray[i];
        if (element !== '') {
            result = element.replace(/ /g, "");
            break;
        }
    }

    if (result) {

        //身分證(統一編號)
        const _idArray = result.match(/[A-Z][12]\d{8}/g);
        if (_idArray && _idArray[0]) {
            // console.log(_idArray[0]);
            inputId.value = _idArray[0];
        }

        //發證地點
        const _cityArray = result.match(/\([\w\W]*\)/g);
        if (_cityArray && _cityArray[0]) {
            // console.log(_cityArray[0].substring(1, _cityArray[0].length - 1)); 
            inputCity.value = _cityArray[0].substring(1, _cityArray[0].length - 1);
        }

        //發證日期
        const _dateArray = result.match(/民國[\w\W]*日/g);
        if (_dateArray && _dateArray[0]) {
            // console.log(_dateArray[0]);
            inputDate.value = _dateArray[0];
        }

        //初發、補發、換發
        const _typeArray = result.match(/初發|補發|換發/g);
        if (_typeArray && _typeArray[0]) {
            // console.log(_typeArray[0]);
            inputType.value = _typeArray[0];
        }

    }
}

const changeFrontImage = (e) => {
    recognize(e, { src: frontImageSrc, handle: frontImageRecognize });
}

const clearFrontImage = (e) => {
    frontImageSrc.value = '';
    inputId.value = '';
    inputDate.value = '';
    inputCity.value = '';
    inputType.value = '';
    idFormVisible.value = false;
}

const changeBackImage = (e) => {
    recognize(e, { src: backImageSrc, handle: null });
}

const clearBackImage = (e) => {
    backImageSrc.value = '';
}

</script>

<template>

    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="3"></Process>
        </div>

        <h2 class="font-bold text-2xl pb-2 ">身分認證</h2>

        <div class="pb-8">

            <div class="mb-4 relative">
                <div class="flex justify-center items-center absolute top-0 bottom-0 left-0 right-0 bg-black opacity-50 z-20 text-white rounded-md" v-if="isRecognizing"> 
                    <div>辨識中</div> 
                </div>
                <ImageUploadBox imageText="正面身分證" :imageSrc="frontImageSrc" :changeHandle="changeFrontImage"
                :clearHandle="clearFrontImage" />
            </div>
            
            <ImageUploadBox imageText="背面身分證" :imageSrc="backImageSrc" :changeHandle="changeBackImage"
                :clearHandle="clearBackImage" />

        </div>

        <div class="mb-8 relative" v-if="idFormVisible">
            <ul class="list">
                <li class="pb-4">
                    <h5 class="font-bold pb-1">身分證 (統一編號)</h5>
                    <input type="text" v-model="inputId" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">發證日期</h5>
                    <input type="text" v-model="inputDate" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">發證地點</h5>
                    <input type="text" v-model="inputCity" />
                </li>
                <li class="pb-4">
                    <h5 class="font-bold pb-1">領補換類別</h5>
                    <input type="text" v-model="inputType" />
                </li>
            </ul>
        </div>


        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="goNextPageDisable" @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>
